import { cn } from "@/lib/utils";

const FormLabel = ({
  children,
  className,
  isCheckbox = false,
}: {
  children: React.ReactNode;
  className?: string;
  isCheckbox?: boolean;
}) => (
  <label
    className={cn(
      "pr-[6px] bg-white text-[14px] leading-[16px] font-normal text-black flex items-center mb-2",
      className,
      isCheckbox ? "" : ""
    )}
  >
    {children}
  </label>
);

export default FormLabel;
